<template>
  <div class="base-like-button">
    <heart
      v-if="!showIcon"
      @liked="onClick(!value, 'big-button')"
      @click="$emit('click')"
    />
    <transition name="fade">
      <base-icon
        v-if="showIcon"
        v-show="show"
        :icon="value ? 'heart-selected' : 'heart'"
        :class="(readonly && '') || 'clickable'"
        @click.native.stop="onClick(!value)"
      />
    </transition>
  </div>
</template>
<script>
import Heart from '@/components/Widgets/Collateral/heart';

export default {
  name: 'BaseLikeButton',
  components: { Heart },
  props: {
    /** Liked or not */
    value: {
      type: Boolean,
      required: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
    likeOnDoubleClick: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    /** If true, works as an indicator only. No interactions are possible. */
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
  methods: {
    onClick(value, source) {
      if (this.readonly) return;
      this.selected = value;

      let data = value;
      if (source) {
        data = { value, source };
      }
      this.$emit('input', data);
    },
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease !important;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
  transform: translateY(-20%);
}

// .base-icon {
//   position: absolute;
//   bottom: 0;
//   z-index: 10;
// }

::v-deep .like-container {
  z-index: 9;
  bottom: 0;
}
</style>
